/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { CheckmarkIcon } from 'shared/components/Icons';

const PollImagePhotos = ({ activeImage, setActiveImage, product }) => {
  const toggleImage = img => {
    setActiveImage(img);
  };

  const images = product && product?.images ? [...new Set(product.images), product.item?.mainImage] : '';

  return (
    <div className='poll-photos d-flex flex-wrap'>
      {images &&
        images.map((item, index) => {
          if (!item) return null;
          const isActive = activeImage === item;
          return (
            <div
              key={index}
              className={`m-2 cursor-pointer ${isActive ? 'poll-image-active' : ''}`}
              onClick={() => toggleImage(item)}
            >
              <img width={92} height={92} src={item} alt='img' className='rounded-6' />
              {isActive && (
                <div className='check-icon d-flex align-items-center justify-content-center'>
                  <CheckmarkIcon className='svg-white' />
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default PollImagePhotos;
